module.exports = __webpack_public_path__ + "img/ident.b5e531cf.jpg";